import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XCircleIcon, AlertCircleIcon, Loader2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
const ComplianceScreeningStep = ({
  onPrev
}) => {
  const [isProcessing, setIsProcessing] = useState(true);
  const [isComplete, setIsComplete] = useState(false);
  // Simulate compliance check process
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsProcessing(false);
      setIsComplete(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  return <div data-id="element-645">
      <h2 className="text-xl font-semibold mb-6" data-id="element-646">Compliance Screening</h2>
      <p className="text-sm text-gray-500 mb-6" data-id="element-647">
        We are verifying your information to ensure compliance with AML, KYC,
        and CFT regulations. This process may take a few moments.
      </p>
      <div className="space-y-6" data-id="element-648">
        <div className="border border-gray-200 rounded-md p-6" data-id="element-649">
          {isProcessing ? <div className="flex flex-col items-center" data-id="element-650">
              <Loader2Icon className="h-12 w-12 text-blue-600 animate-spin mb-4" data-id="element-651" />
              <h3 className="font-medium text-lg mb-2" data-id="element-652">
                Processing Compliance Checks
              </h3>
              <p className="text-gray-500 text-center" data-id="element-653">
                Please wait while we verify your information. This may take a
                few moments.
              </p>
            </div> : isComplete ? <div className="flex flex-col items-center" data-id="element-654">
              <CheckCircleIcon className="h-12 w-12 text-green-500 mb-4" data-id="element-655" />
              <h3 className="font-medium text-lg mb-2" data-id="element-656">
                Compliance Checks Complete
              </h3>
              <p className="text-gray-500 text-center mb-6" data-id="element-657">
                Your information has been verified successfully. You can now
                proceed to your merchant dashboard.
              </p>
              <Link to="/dashboard" className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-center" data-id="element-658">
                Go to Dashboard
              </Link>
            </div> : <div className="flex flex-col items-center" data-id="element-659">
              <AlertCircleIcon className="h-12 w-12 text-yellow-500 mb-4" data-id="element-660" />
              <h3 className="font-medium text-lg mb-2" data-id="element-661">
                Additional Verification Required
              </h3>
              <p className="text-gray-500 text-center mb-4" data-id="element-662">
                We need some additional information to complete your
                verification. Our team will contact you shortly.
              </p>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-663">
                Contact Support
              </button>
            </div>}
        </div>
        <div className="space-y-3" data-id="element-664">
          <div className="flex items-center" data-id="element-665">
            <div className="flex-shrink-0 mr-3" data-id="element-666">
              {isProcessing ? <Loader2Icon className="h-5 w-5 text-blue-600 animate-spin" data-id="element-667" /> : <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-668" />}
            </div>
            <div data-id="element-669">
              <h4 className="font-medium" data-id="element-670">Identity Verification</h4>
              <p className="text-sm text-gray-500" data-id="element-671">
                Verifying identity documents
              </p>
            </div>
          </div>
          <div className="flex items-center" data-id="element-672">
            <div className="flex-shrink-0 mr-3" data-id="element-673">
              {isProcessing ? <Loader2Icon className="h-5 w-5 text-blue-600 animate-spin" data-id="element-674" /> : <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-675" />}
            </div>
            <div data-id="element-676">
              <h4 className="font-medium" data-id="element-677">Business Verification</h4>
              <p className="text-sm text-gray-500" data-id="element-678">
                Confirming business registration details
              </p>
            </div>
          </div>
          <div className="flex items-center" data-id="element-679">
            <div className="flex-shrink-0 mr-3" data-id="element-680">
              {isProcessing ? <Loader2Icon className="h-5 w-5 text-blue-600 animate-spin" data-id="element-681" /> : <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-682" />}
            </div>
            <div data-id="element-683">
              <h4 className="font-medium" data-id="element-684">AML Screening</h4>
              <p className="text-sm text-gray-500" data-id="element-685">
                Checking against anti-money laundering databases
              </p>
            </div>
          </div>
          <div className="flex items-center" data-id="element-686">
            <div className="flex-shrink-0 mr-3" data-id="element-687">
              {isProcessing ? <Loader2Icon className="h-5 w-5 text-blue-600 animate-spin" data-id="element-688" /> : <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-689" />}
            </div>
            <div data-id="element-690">
              <h4 className="font-medium" data-id="element-691">Bank Account Verification</h4>
              <p className="text-sm text-gray-500" data-id="element-692">
                Validating banking information
              </p>
            </div>
          </div>
        </div>
        {!isComplete && <div className="pt-4 flex justify-start" data-id="element-693">
            <button type="button" onClick={onPrev} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={isProcessing} data-id="element-694">
              Back
            </button>
          </div>}
      </div>
    </div>;
};
export default ComplianceScreeningStep;